export default "__VITE_PUBLIC_ASSET__e6ee51c9__"